// Generated by purs version 0.13.8
"use strict";
var Color = require("../Color/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State = require("../Control.Monad.State/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Lens_At = require("../Data.Lens.At/index.js");
var Data_Lens_Fold = require("../Data.Lens.Fold/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Index = require("../Data.Lens.Index/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Iso_Newtype = require("../Data.Lens.Iso.Newtype/index.js");
var Data_Lens_Lens = require("../Data.Lens.Lens/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Lens_Prism_Maybe = require("../Data.Lens.Prism.Maybe/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Lens_Traversal = require("../Data.Lens.Traversal/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Maybe_First = require("../Data.Maybe.First/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Monoid_Additive = require("../Data.Monoid.Additive/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Profunctor = require("../Data.Profunctor/index.js");
var Data_Profunctor_Choice = require("../Data.Profunctor.Choice/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Editor_Type = require("../Lunarbox.Capability.Editor.Type/index.js");
var Lunarbox_Control_Monad_Dataflow_Interpreter = require("../Lunarbox.Control.Monad.Dataflow.Interpreter/index.js");
var Lunarbox_Control_Monad_Dataflow_Interpreter_Interpret = require("../Lunarbox.Control.Monad.Dataflow.Interpreter.Interpret/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve_SolveExpression = require("../Lunarbox.Control.Monad.Dataflow.Solve.SolveExpression/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve_Unify = require("../Lunarbox.Control.Monad.Dataflow.Solve.Unify/index.js");
var Lunarbox_Data_Class_GraphRep = require("../Lunarbox.Data.Class.GraphRep/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Expression_Lint = require("../Lunarbox.Data.Dataflow.Expression.Lint/index.js");
var Lunarbox_Data_Dataflow_Expression_Optimize = require("../Lunarbox.Data.Dataflow.Expression.Optimize/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Runtime_TermEnvironment = require("../Lunarbox.Data.Dataflow.Runtime.TermEnvironment/index.js");
var Lunarbox_Data_Dataflow_Runtime_ValueMap = require("../Lunarbox.Data.Dataflow.Runtime.ValueMap/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_DataflowFunction = require("../Lunarbox.Data.Editor.DataflowFunction/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Editor_NodeGroup = require("../Lunarbox.Data.Editor.NodeGroup/index.js");
var Lunarbox_Data_Editor_Project = require("../Lunarbox.Data.Editor.Project/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var Lunarbox_Data_Ord = require("../Lunarbox.Data.Ord/index.js");
var Lunarbox_Data_Tab = require("../Lunarbox.Data.Tab/index.js");
var Lunarbox_Foreign_Render = require("../Lunarbox.Foreign.Render/index.js");
var Record = require("../Record/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var MoveToFunction = (function () {
    function MoveToFunction(value0) {
        this.value0 = value0;
    };
    MoveToFunction.create = function (value0) {
        return new MoveToFunction(value0);
    };
    return MoveToFunction;
})();
var CenterNode = (function () {
    function CenterNode(value0) {
        this.value0 = value0;
    };
    CenterNode.create = function (value0) {
        return new CenterNode(value0);
    };
    return CenterNode;
})();
var CenterOutput = (function () {
    function CenterOutput() {

    };
    CenterOutput.value = new CenterOutput();
    return CenterOutput;
})();
var withCurrentNode_ = function (dictMonadState) {
    return function (f) {
        return Data_Functor["void"]((((dictMonadState.Monad0()).Bind1()).Apply0()).Functor0())(Control_Bind.bind((dictMonadState.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(function (v) {
            return v.currentlyEditedNode;
        }))(Data_Traversable.traverse(Data_Traversable.traversableMaybe)((dictMonadState.Monad0()).Applicative0())(f)));
    };
};
var tryCompiling = function (v) {
    var expression$prime = Lunarbox_Data_Editor_Project.compileProject(v.project);
    var result = (function () {
        var lintingErrors = Lunarbox_Data_Dataflow_Expression_Lint.lint(expression$prime);
        var v1 = Lunarbox_Control_Monad_Dataflow_Solve_SolveExpression.solveExpression(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.showLocation)(expression$prime);
        return {
            typeErrors: v1.value1.errors,
            lintingErrors: lintingErrors,
            typeMap: v1.value0,
            expression: Lunarbox_Data_Dataflow_Expression_Optimize.inline(Lunarbox_Data_Editor_Location.eqLocation)(Lunarbox_Data_Dataflow_Expression_Optimize.dce(Lunarbox_Data_Editor_Location.eqLocation)(expression$prime))
        };
    })();
    return result;
};
var preventDefaults = function (dictMonadEffect) {
    return function (event) {
        return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Control_Apply.applySecond(Effect.applyEffect)(Web_Event_Event.preventDefault(event))(Web_Event_Event.stopPropagation(event)));
    };
};
var moveTo = function (v) {
    if (v instanceof Lunarbox_Data_Editor_Location.UnknownLocation) {
        return [  ];
    };
    if (v instanceof Lunarbox_Data_Editor_Location.AtFunction) {
        return [ new MoveToFunction(v.value0) ];
    };
    if (v instanceof Lunarbox_Data_Editor_Location.AtFunctionDeclaration) {
        return [ new MoveToFunction(v.value0) ];
    };
    if (v instanceof Lunarbox_Data_Editor_Location.FixpointOperator) {
        return [ new MoveToFunction(v.value0) ];
    };
    if (v instanceof Lunarbox_Data_Editor_Location.InsideFunction) {
        var go = function (v1) {
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.NodeLocation) {
                return [ new CenterNode(v1.value0) ];
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.NodeDefinition) {
                return [ new CenterNode(v1.value0) ];
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.PinLocation) {
                return [ new CenterNode(v1.value0) ];
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.AtApplication) {
                return [ new CenterNode(v1.value0) ];
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.FunctionDeclaration) {
                return [ CenterOutput.value ];
            };
            return [  ];
        };
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ new MoveToFunction(v.value0) ])(go(v.value1));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.State (line 546, column 1 - line 546, column 41): " + [ v.constructor.name ]);
};
var inputNodeName = "input";
var getNodeValue = function (currentFunction) {
    return function (v) {
        return function (id) {
            return function (v1) {
                if (v1 instanceof Lunarbox_Data_Editor_Node.ComplexNode) {
                    return Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.InsideFunction.create(currentFunction)(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(id)))(v);
                };
                if (v1 instanceof Lunarbox_Data_Editor_Node.OutputNode) {
                    return Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.InsideFunction.create(currentFunction)(Lunarbox_Data_Editor_Node_PinLocation.PinLocation.create(id)(new Lunarbox_Data_Editor_Node_PinLocation.InputPin(0))))(v);
                };
                return Data_Maybe.Nothing.value;
            };
        };
    };
};
var getNodeType = function (id) {
    return function (v) {
        return function (v1) {
            if (v === "if") {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.InsideFunction(v1.currentFunction, new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(id)))(v1.typeMap))(function (output) {
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Lunarbox_Data_Dataflow_Type.multiArgumentFuncion([ Lunarbox_Data_Dataflow_Type.typeBool, output, output ])(output));
                });
            };
            return Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.InsideFunction(v1.currentFunction, new Lunarbox_Data_Editor_Node_PinLocation.FunctionUsage(id, v)))(v1.typeMap);
        };
    };
};
var getMaxInputs = function (name) {
    return function (v) {
        var v1 = Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(v.functionData);
        if (v1 instanceof Data_Maybe.Just) {
            return Data_Array.length(v1.value0.inputs);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            var v2 = Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(v.project.functions);
            if (v2 instanceof Data_Maybe.Just && v2.value0 instanceof Lunarbox_Data_Editor_DataflowFunction.VisualFunction) {
                return Data_List.length(v2.value0.value0.inputs);
            };
            return 0;
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.State (line 503, column 70 - line 507, column 11): " + [ v1.constructor.name ]);
    };
};
var getFunctionColorMap = function (v) {
    return function (v1) {
        if (v === 0) {
            return {
                inputs: [  ],
                output: Data_Nullable.notNull(Color.cssStringRGBA(Lunarbox_Capability_Editor_Type.typeToColor(v1)))
            };
        };
        if (v1 instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v1.value0 === "Function" && v1.value1.length === 2)) {
            var next = getFunctionColorMap(v - 1 | 0)(v1["value1"][1]);
            return {
                inputs: Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Data_Nullable.notNull(Color.cssStringRGBA(Lunarbox_Capability_Editor_Type.typeToColor(v1["value1"][0]))) ])(next.inputs),
                output: next.output
            };
        };
        return getFunctionColorMap(0)(v1);
    };
};
var evaluate = function (v) {
    var context = {
        location: Lunarbox_Data_Editor_Location.UnknownLocation.value,
        termEnv: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Runtime_TermEnvironment.monoidTermEnvironment),
        overwrites: v.runtimeOverwrites,
        toplevel: true
    };
    var valueMap = Data_Tuple.snd(Lunarbox_Control_Monad_Dataflow_Interpreter.runInterpreter(Lunarbox_Data_Editor_Location.ordLocation)(context)(Lunarbox_Control_Monad_Dataflow_Interpreter_Interpret.interpret(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.defaultLocation)(v.expression)));
    return {
        project: v.project,
        nextId: v.nextId,
        geometries: v.geometries,
        runtimeOverwrites: v.runtimeOverwrites,
        currentFunction: v.currentFunction,
        expression: v.expression,
        typeMap: v.typeMap,
        typeErrors: v.typeErrors,
        lintingErrors: v.lintingErrors,
        currentTab: v.currentTab,
        functionData: v.functionData,
        panelIsOpen: v.panelIsOpen,
        valueMap: valueMap,
        inputCountMap: v.inputCountMap,
        pendingConnection: v.pendingConnection,
        name: v.name,
        isExample: v.isExample,
        isAdmin: v.isAdmin,
        nodeSearchTerm: v.nodeSearchTerm,
        isVisible: v.isVisible,
        currentlyEditedNode: v.currentlyEditedNode,
        autosaveInterval: v.autosaveInterval,
        emitInterval: v.emitInterval
    };
};
var compile = function (state) {
    var overwrites = tryCompiling(state);
    return evaluate(Record.merge()()(overwrites)(state));
};
var _valueMap = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "valueMap";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _typeMap = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "typeMap";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _runtimeOverwrites = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "runtimeOverwrites";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _project = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "project";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _panelIsOpen = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "panelIsOpen";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _nodeSearchTerm = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "nodeSearchTerm";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _nodeGroup = function (name) {
    return function (dictWander) {
        var $186 = _project(dictWander.Strong0());
        var $187 = Lunarbox_Data_Editor_Project["_projectNodeGroup"](name)(dictWander);
        return function ($188) {
            return $186($187($188));
        };
    };
};
var _nodes = function (name) {
    return function (dictWander) {
        var $189 = _nodeGroup(name)(dictWander);
        var $190 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupNodes"](dictWander.Strong0());
        return function ($191) {
            return $189($190($191));
        };
    };
};
var getOutputType = function (functionName) {
    return function (id) {
        return function (state) {
            var typeMap = Data_Lens_Getter.view(_typeMap(Data_Lens_Internal_Forget.strongForget))(state);
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Lens_Fold.preview(_nodeGroup(functionName)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state))(function (nodeGroup) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.AtFunction(functionName))(typeMap))(function (currentFunctionType) {
                    var inputIndex = Data_List.findIndex(function (v) {
                        return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(v)(id);
                    })(Data_Lens_Getter.view(Lunarbox_Data_Editor_NodeGroup["_NodeGroupInputs"](Data_Lens_Internal_Forget.strongForget))(nodeGroup));
                    if (inputIndex instanceof Data_Maybe.Just) {
                        return Data_List.index(Lunarbox_Data_Dataflow_Type.inputs(currentFunctionType))(inputIndex.value0);
                    };
                    if (inputIndex instanceof Data_Maybe.Nothing) {
                        return Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.InsideFunction.create(functionName)(new Lunarbox_Data_Editor_Node_PinLocation.PinLocation(id, Lunarbox_Data_Editor_Node_PinLocation.OutputPin.value)))(typeMap);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Data.Editor.State (line 260, column 3 - line 262, column 91): " + [ inputIndex.constructor.name ]);
                });
            });
        };
    };
};
var _nextId = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "nextId";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var createId = Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.gets(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Getter.view(_nextId(Data_Lens_Internal_Forget.strongForget))))(function (nextId) {
    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over(_nextId(Data_Profunctor_Strong.strongFn))(function (v) {
        return v + 1 | 0;
    })))(function () {
        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Lunarbox_Data_Editor_Node_NodeId.NodeId(Data_Show.show(Data_Show.showInt)(nextId)));
    });
});
var _name = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _isVisible = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "isVisible";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _isExample = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "isExample";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _isAdmin = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "isAdmin";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _inputCountMap = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "inputCountMap";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _geometries = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "geometries";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _functions = function (dictStrong) {
    var $192 = _project(dictStrong);
    var $193 = Lunarbox_Data_Editor_Project["_ProjectFunctions"](dictStrong);
    return function ($194) {
        return $192($193($194));
    };
};
var nodeCount = (function () {
    var go = function (v) {
        if (v instanceof Lunarbox_Data_Editor_DataflowFunction.VisualFunction) {
            return Data_Foldable.length(Data_Map_Internal.foldableMap)(Data_Semiring.semiringInt)(v.value0.nodes);
        };
        return 0;
    };
    var $195 = Data_Newtype.unwrap(Data_Newtype.newtypeAdditive);
    var $196 = Data_Foldable.foldMap(Data_Map_Internal.foldableMap)(Data_Monoid_Additive.monoidAdditive(Data_Semiring.semiringInt))(function ($199) {
        return Data_Monoid_Additive.Additive(go($199));
    });
    var $197 = Data_Lens_Getter.view(_functions(Data_Lens_Internal_Forget.strongForget));
    return function ($198) {
        return $195($196($197($198)));
    };
})();
var visualFunctionCount = (function () {
    var $200 = Data_Filterable.filter(Data_Filterable.filterableMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](Data_Lens_Internal_Market.choiceMarket)));
    var $201 = Data_Lens_Getter.view(_functions(Data_Lens_Internal_Forget.strongForget));
    return function ($202) {
        return Data_Map_Internal.size($200($201($202)));
    };
})();
var _functionData = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "functionData";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var functionExists = function (name) {
    var $203 = Data_Map_Internal.member(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name);
    var $204 = Data_Lens_Getter.view(_functionData(Data_Lens_Internal_Forget.strongForget));
    return function ($205) {
        return $203($204($205));
    };
};
var searchNode = function (state) {
    var searchTerm = Data_Lens_Getter.view(_nodeSearchTerm(Data_Lens_Internal_Forget.strongForget))(state);
    var nodes = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(Data_Lens_Getter.view(_functionData(Data_Lens_Internal_Forget.strongForget))(state)));
    return Lunarbox_Data_Ord.sortBySearch(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName))(searchTerm)(nodes);
};
var _function = function (name) {
    return function (dictWander) {
        var $206 = _project(dictWander.Strong0());
        var $207 = Lunarbox_Data_Editor_Project["_atProjectFunction"](name)(dictWander);
        return function ($208) {
            return $206($207($208));
        };
    };
};
var _expression = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "expression";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _currentTab = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "currentTab";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _currentFunction = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "currentFunction";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _currentNodeGroup = function (dictStrong) {
    return Data_Lens_Lens.lens(function (state) {
        var current = Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state);
        return Data_Lens_Fold.preview(_nodeGroup(current)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state);
    })(function (state) {
        return function (maybeValue) {
            return Data_Maybe.fromMaybe(state)((function () {
                var currentFunction = Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state);
                return Control_Bind.bind(Data_Maybe.bindMaybe)(maybeValue)(function (value) {
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Lens_Setter.set(_nodeGroup(currentFunction)(Data_Lens_Internal_Wander.wanderFunction))(value)(state));
                });
            })());
        };
    })(dictStrong);
};
var _currentNodes = function (dictWander) {
    var $209 = _currentNodeGroup(dictWander.Strong0());
    var $210 = Data_Lens_Prism_Maybe["_Just"](dictWander.Choice1());
    var $211 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupNodes"](dictWander.Strong0());
    return function ($212) {
        return $209($210($211($212)));
    };
};
var canConnect = function (from) {
    return function (v) {
        return function (state) {
            return Data_Maybe.fromMaybe(false)((function () {
                var typeMap = Data_Lens_Getter.view(_typeMap(Data_Lens_Internal_Forget.strongForget))(state);
                var currentFunction = Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state);
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Lens_Fold.preview(_currentNodes(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state))(function (nodes) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(!Lunarbox_Data_Graph.wouldCreateCycle(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(from)(v.value0)(Lunarbox_Data_Class_GraphRep.toGraph(Lunarbox_Data_Class_GraphRep.graphRepDependencyMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Lunarbox_Data_Editor_Node.dependsNode))(nodes))))(function () {
                        return Control_Bind.bind(Data_Maybe.bindMaybe)(getOutputType(currentFunction)(from)(state))(function (fromType) {
                            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.InsideFunction.create(currentFunction)(Lunarbox_Data_Editor_Node_PinLocation.PinLocation.create(v.value0)(new Lunarbox_Data_Editor_Node_PinLocation.InputPin(v.value1))))(typeMap))(function (toType) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(Lunarbox_Control_Monad_Dataflow_Solve_Unify.canUnify(toType)(fromType)))(function () {
                                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(true);
                                });
                            });
                        });
                    });
                });
            })());
        };
    };
};
var generateUnconnectableInputs = function (output) {
    return function (state) {
        var nodeGroup = Data_Maybe.maybe(Data_Monoid.mempty(Data_List_Types.monoidList))(Data_Map_Internal.toUnfoldable(Data_List_Types.unfoldableList))(Data_Lens_Fold.preview(_currentNodes(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state));
        var allInputs = Data_Set.fromFoldable(Data_List_Types.foldableList)(Data_Tuple.ordTuple(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Data_Ord.ordInt))(Control_Bind.bindFlipped(Data_List_Types.bindList)(function (v) {
            return Data_List.mapWithIndex((function () {
                var $213 = Data_Tuple.Tuple.create(v.value0);
                return function ($214) {
                    return Data_Function["const"]($213($214));
                };
            })())(Data_Lens_Getter.view(Lunarbox_Data_Editor_Node["_nodeInputs"](Data_Lens_Internal_Forget.strongForget))(v.value1));
        })(nodeGroup));
        var unconnectableInputs = Data_Set.filter(Data_Tuple.ordTuple(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Data_Ord.ordInt))((function () {
            var $215 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
            var $216 = Data_Function.flip(canConnect(output))(state);
            return function ($217) {
                return $215($216($217));
            };
        })())(allInputs);
        return Data_Set.map(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "index";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "id";
        }))(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)))(function (v) {
            return {
                id: v.value0,
                index: v.value1
            };
        })(unconnectableInputs);
    };
};
var setCurrentFunction = Data_Lens_Setter.set(_currentFunction(Data_Profunctor_Strong.strongFn));
var withCurrentFunction = function (dictMonadState) {
    return function (f) {
        return Control_Bind.bind((dictMonadState.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))))(f);
    };
};
var withCurrentFunction_ = function (dictMonadState) {
    var $218 = Data_Functor["void"]((((dictMonadState.Monad0()).Bind1()).Apply0()).Functor0());
    var $219 = withCurrentFunction(dictMonadState);
    return function ($220) {
        return $218($219($220));
    };
};
var _atNode = function (name) {
    return function (id) {
        return function (dictWander) {
            var $221 = _project(dictWander.Strong0());
            var $222 = Lunarbox_Data_Editor_Project["_atProjectNode"](name)(id)(dictWander);
            var $223 = Data_Lens_Prism_Maybe["_Just"](dictWander.Choice1());
            return function ($224) {
                return $221($222($223($224)));
            };
        };
    };
};
var deleteNode = function (functionName) {
    return function (id) {
        return function (state) {
            var node = Data_Lens_Fold.preview(_atNode(functionName)(id)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state);
            var isOutput = Data_Maybe.maybe(false)(Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(Lunarbox_Data_Editor_Node["_OutputNode"](Data_Lens_Internal_Market.choiceMarket)))(node);
            return Data_Function.flip(Control_Monad_State.execState)(state)(Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(!isOutput)(Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                var $225 = _nodes(functionName)(Data_Lens_Internal_Wander.wanderFunction);
                var $226 = Data_Lens_Traversal.traversed(Data_Map_Internal.traversableMap)(Data_Lens_Internal_Wander.wanderFunction);
                var $227 = Lunarbox_Data_Editor_Node["_nodeInputs"](Data_Profunctor_Strong.strongFn);
                var $228 = Data_Lens_Traversal.traversed(Data_List_Types.traversableList)(Data_Lens_Internal_Wander.wanderFunction);
                return function ($229) {
                    return $225($226($227($228($229))));
                };
            })())(function (input) {
                var $150 = Data_Eq.eq(Data_Maybe.eqMaybe(Lunarbox_Data_Editor_Node_NodeId.eqNodeId))(input)(new Data_Maybe.Just(id));
                if ($150) {
                    return Data_Maybe.Nothing.value;
                };
                return input;
            })))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                    var $230 = _currentNodeGroup(Data_Profunctor_Strong.strongFn);
                    var $231 = Data_Lens_Prism_Maybe["_Just"](Data_Profunctor_Choice.choiceFn);
                    var $232 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupInputs"](Data_Profunctor_Strong.strongFn);
                    return function ($233) {
                        return $230($231($232($233)));
                    };
                })())(Data_Filterable.filter(Data_Filterable.filterableList)(function (v) {
                    return Data_Eq.notEq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(id)(v);
                }))))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                        var $234 = _currentNodeGroup(Data_Profunctor_Strong.strongFn);
                        var $235 = Data_Lens_Prism_Maybe["_Just"](Data_Profunctor_Choice.choiceFn);
                        var $236 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupNodes"](Data_Profunctor_Strong.strongFn);
                        return function ($237) {
                            return $234($235($236($237)));
                        };
                    })())(Data_Map_Internal.filterKeys(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(function (v) {
                        return Data_Eq.notEq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(id)(v);
                    }))))(function () {
                        return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(compile);
                    });
                });
            })));
        };
    };
};
var deleteFunctionReferences = function (toDelete) {
    return function (functionName) {
        return function (graph) {
            return function (state) {
                return Data_Foldable.foldr(Data_List_Types.foldableList)(deleteNode(functionName))(state)(Data_Filterable.filterMap(Data_Filterable.filterableList)(function (v) {
                    var $152 = Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(Lunarbox_Data_Editor_Node.getFunctionName(v.value1))(toDelete);
                    if ($152) {
                        return new Data_Maybe.Just(v.value0);
                    };
                    return Data_Maybe.Nothing.value;
                })(Data_Map_Internal.toUnfoldable(Data_List_Types.unfoldableList)(graph)));
            };
        };
    };
};
var removeConnection = function (v) {
    return Control_Monad_State.execState(withCurrentFunction_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(function (currentFunction) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set((function () {
            var $238 = _atNode(currentFunction)(v.value0)(Data_Lens_Internal_Wander.wanderFunction);
            var $239 = Lunarbox_Data_Editor_Node["_nodeInput"](v.value1)(Data_Lens_Internal_Wander.wanderFunction);
            return function ($240) {
                return $238($239($240));
            };
        })())(Data_Maybe.Nothing.value)))(function () {
            return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(compile);
        });
    }));
};
var generateUnconnectableOutputs = function (input) {
    return function (state) {
        var state$prime = removeConnection(input)(state);
        var outputNode = Data_Lens_Fold.preview((function () {
            var $241 = _currentNodeGroup(Data_Lens_Internal_Forget.strongForget);
            var $242 = Data_Lens_Prism_Maybe["_Just"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
            var $243 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupOutput"](Data_Lens_Internal_Forget.strongForget);
            return function ($244) {
                return $241($242($243($244)));
            };
        })())(state$prime);
        var keys = Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)))(Data_Map.keys)(Data_Lens_Fold.preview(_currentNodes(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state$prime));
        var outputs = (function () {
            if (outputNode instanceof Data_Maybe.Just) {
                return Data_Set.difference(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(keys)(Data_Set.singleton(outputNode.value0));
            };
            if (outputNode instanceof Data_Maybe.Nothing) {
                return keys;
            };
            throw new Error("Failed pattern match at Lunarbox.Data.Editor.State (line 290, column 13 - line 292, column 20): " + [ outputNode.constructor.name ]);
        })();
        return Data_Set.filter(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(function (outputId) {
            return !canConnect(outputId)(input)(state$prime);
        })(outputs);
    };
};
var _atInputCount = function (name) {
    return function (dictWander) {
        var $245 = _inputCountMap(dictWander.Strong0());
        var $246 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictWander.Strong0());
        return function ($247) {
            return $245($246($247));
        };
    };
};
var _atGeometry = function (name) {
    return function (dictStrong) {
        var $248 = _geometries(dictStrong);
        var $249 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictStrong);
        return function ($250) {
            return $248($249($250));
        };
    };
};
var _currentGeometryCache = function (dictStrong) {
    return Data_Lens_Lens.lens(function (state) {
        var currentFunction = Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state);
        return Data_Lens_Getter.view(_atGeometry(currentFunction)(Data_Lens_Internal_Forget.strongForget))(state);
    })(function (state) {
        return function (maybeValue) {
            var currentFunction = Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state);
            return Data_Lens_Setter.set(_atGeometry(currentFunction)(Data_Profunctor_Strong.strongFn))(maybeValue)(state);
        };
    })(dictStrong);
};
var withCurrentGeometries = function (dictMonadState) {
    return function (f) {
        return Control_Bind.bind((dictMonadState.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Getter.view(_currentGeometryCache(Data_Lens_Internal_Forget.strongForget))))(Data_Traversable.traverse(Data_Traversable.traversableMaybe)((dictMonadState.Monad0()).Applicative0())(f));
    };
};
var _atFunctionData = function (name) {
    return function (dictWander) {
        var $251 = _functionData(dictWander.Strong0());
        var $252 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictWander.Strong0());
        return function ($253) {
            return $251($252($253));
        };
    };
};
var deleteFunction = function (toDelete) {
    return function (state) {
        var main = Data_Lens_Getter.view(Lunarbox_Data_Editor_Project["_ProjectMain"](Data_Lens_Internal_Forget.strongForget))(state.project);
        return Data_Function.flip(Control_Monad_State.execState)(state)(Control_Applicative.unless(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(main)(toDelete))((function () {
            var visualFunctions = Data_Filterable.filterMap(Data_Filterable.filterableList)(function (v) {
                return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create(v.value0))(Data_Lens_Fold.preview(Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst)))(v.value1));
            })(Data_Map_Internal.toUnfoldable(Data_List_Types.unfoldableList)(Data_Lens_Getter.view(_functions(Data_Lens_Internal_Forget.strongForget))(state)));
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.put(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Foldable.foldr(Data_List_Types.foldableList)(function (v) {
                return deleteFunctionReferences(toDelete)(v.value0)(Data_Lens_Getter.view(Lunarbox_Data_Editor_NodeGroup["_NodeGroupNodes"](Data_Lens_Internal_Forget.strongForget))(v.value1));
            })(state)(visualFunctions)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set(_atFunctionData(toDelete)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Nothing.value)))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set(_function(toDelete)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Nothing.value)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                            var $254 = _runtimeOverwrites(Data_Profunctor_Strong.strongFn);
                            var $255 = Data_Lens_Iso_Newtype["_Newtype"](Lunarbox_Data_Dataflow_Runtime_ValueMap.newtypeValueMap)(Lunarbox_Data_Dataflow_Runtime_ValueMap.newtypeValueMap)(Data_Profunctor.profunctorFn);
                            return function ($256) {
                                return $254($255($256));
                            };
                        })())(Data_Map_Internal.filterKeys(Lunarbox_Data_Editor_Location.ordLocation)((function () {
                            var $257 = Data_Lens_Getter.view(Lunarbox_Data_Editor_Location["_Function"](Data_Lens_Internal_Forget.strongForget));
                            return function ($258) {
                                return (function (v) {
                                    return Data_Eq.notEq(Data_Maybe.eqMaybe(Lunarbox_Data_Editor_FunctionName.eqFunctionName))(v)(new Data_Maybe.Just(toDelete));
                                })($257($258));
                            };
                        })()))))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set(_atInputCount(toDelete)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Nothing.value)))(function () {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set(_atGeometry(toDelete)(Data_Profunctor_Strong.strongFn))(Data_Maybe.Nothing.value)))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(Data_Lens_Getter.view(_currentFunction(Data_Lens_Internal_Forget.strongForget))(state))(toDelete))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.set(_currentFunction(Data_Profunctor_Strong.strongFn))(main))))(function () {
                                        return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(compile);
                                    });
                                });
                            });
                        });
                    });
                });
            });
        })()));
    };
};
var initializeFunction = function (dictMonadEffect) {
    return function (name) {
        return function (state) {
            return Data_Function.flip(Control_Monad_State_Trans.execStateT((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0()))(state)((function () {
                var id = Lunarbox_Data_Editor_Node_NodeId.NodeId(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name) + "-output");
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Effect_Class.liftEffect(Control_Monad_State_Trans.monadEffectState(dictMonadEffect))(Lunarbox_Foreign_Render.emptyGeometryCache))(function (cache) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Effect_Class.liftEffect(Control_Monad_State_Trans.monadEffectState(dictMonadEffect))(Lunarbox_Foreign_Render.createNode(cache)(id)(1)(false)(Data_Nullable["null"])))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(dictMonadEffect.Monad0()))(Data_Lens_Setter.over(_project(Data_Profunctor_Strong.strongFn))(Lunarbox_Data_Editor_Project.createFunction(name)(id))))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(dictMonadEffect.Monad0()))(setCurrentFunction(name)))(function () {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(dictMonadEffect.Monad0()))(Data_Lens_Setter.set(_currentGeometryCache(Data_Profunctor_Strong.strongFn))(new Data_Maybe.Just(cache))))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(dictMonadEffect.Monad0()))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(dictMonadEffect.Monad0()))(Data_Lens_Setter.set(_atFunctionData(name)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Just.create(Lunarbox_Data_Editor_FunctionData.internal([  ])({
                                        name: Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name) + "-output",
                                        description: "The output of a custom functions"
                                    })))))(function () {
                                        return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(dictMonadEffect.Monad0()))(compile);
                                    });
                                });
                            });
                        });
                    });
                });
            })());
        };
    };
};
var emptyState = function (dictMonadEffect) {
    return initializeFunction(dictMonadEffect)("main")({
        currentTab: Lunarbox_Data_Tab.Settings.value,
        currentFunction: "main",
        nextId: 0,
        panelIsOpen: false,
        typeMap: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_Location.ordLocation)),
        functionData: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)),
        valueMap: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(Lunarbox_Data_Editor_Location.ordLocation)),
        runtimeOverwrites: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(Lunarbox_Data_Editor_Location.ordLocation)),
        inputCountMap: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)),
        geometries: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)),
        expression: new Lunarbox_Data_Dataflow_Expression.TypedHole(Lunarbox_Data_Editor_Location.UnknownLocation.value),
        project: {
            main: "main",
            functions: Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))
        },
        name: "Unnamed project",
        nodeSearchTerm: "",
        isExample: false,
        isAdmin: false,
        isVisible: false,
        pendingConnection: Data_Maybe.Nothing.value,
        typeErrors: [  ],
        lintingErrors: [  ],
        currentlyEditedNode: Data_Maybe.Nothing.value,
        autosaveInterval: Data_Maybe.Just.create(3000.0),
        emitInterval: Data_Maybe.Nothing.value
    });
};
var _atCurrentNode = function (id) {
    return function (dictWander) {
        var $259 = _currentNodes(dictWander);
        var $260 = Data_Lens_Index.ix(Data_Lens_Index.indexMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId))(id)(dictWander);
        return function ($261) {
            return $259($260($261));
        };
    };
};
var createConnection = function (from) {
    return function (toId) {
        return function (toIndex) {
            return Data_Lens_Setter.set((function () {
                var $262 = _atCurrentNode(toId)(Data_Lens_Internal_Wander.wanderFunction);
                var $263 = Lunarbox_Data_Editor_Node["_nodeInput"](toIndex)(Data_Lens_Internal_Wander.wanderFunction);
                return function ($264) {
                    return $262($263($264));
                };
            })())(new Data_Maybe.Just(from));
        };
    };
};
var updateNode = function (dictMonadState) {
    return function (dictMonadEffect) {
        return function (id) {
            var go = function (v) {
                return function (color) {
                    return function (map) {
                        if (v instanceof Lunarbox_Data_Editor_Node_PinLocation.OutputPin) {
                            return {
                                output: Data_Nullable.notNull(Color.cssStringRGBA(color)),
                                inputs: map.inputs
                            };
                        };
                        if (v instanceof Lunarbox_Data_Editor_Node_PinLocation.InputPin) {
                            return {
                                inputs: Data_Maybe.fromMaybe(map.inputs)(Data_Array.updateAt(v.value0)(Data_Nullable.notNull(Color.cssStringRGBA(color)))(map.inputs)),
                                output: map.output
                            };
                        };
                        throw new Error("Failed pattern match at Lunarbox.Data.Editor.State (line 196, column 3 - line 196, column 83): " + [ v.constructor.name, color.constructor.name, map.constructor.name ]);
                    };
                };
            };
            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Getter.view(_currentGeometryCache(Data_Lens_Internal_Forget.strongForget))))(Data_Foldable.traverse_((dictMonadEffect.Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(function (cache) {
                return withCurrentFunction(dictMonadState)(function (currentFunction) {
                    return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Fold.preview(_atCurrentNode(id)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(Data_Foldable.traverse_((dictMonadEffect.Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(function (node) {
                        return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.get(dictMonadState))(function (v) {
                            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Fold.preview(_nodeGroup(currentFunction)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(function (nodeGroup) {
                                var inputs = Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Lens_Getter.view(Lunarbox_Data_Editor_Node["_nodeInputs"](Data_Lens_Internal_Forget.strongForget))(node));
                                var ctx = Data_Lens_Setter.over(Data_Lens_Iso_Newtype["_Newtype"](Lunarbox_Control_Monad_Dataflow_Interpreter.newtypeInterpreterContent)(Lunarbox_Control_Monad_Dataflow_Interpreter.newtypeInterpreterContent)(Data_Profunctor.profunctorFn))(function (v1) {
                                    var $171 = {};
                                    for (var $172 in v1) {
                                        if ({}.hasOwnProperty.call(v1, $172)) {
                                            $171[$172] = v1[$172];
                                        };
                                    };
                                    $171.overwrites = v.runtimeOverwrites;
                                    return $171;
                                })(Data_Default.def(Lunarbox_Control_Monad_Dataflow_Interpreter.defInterpreterContext(Lunarbox_Data_Editor_Location.defaultLocation)(Lunarbox_Data_Editor_Location.ordLocation)));
                                var value = Data_Nullable.toNullable(Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                                    var $265 = Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue);
                                    var $266 = Lunarbox_Control_Monad_Dataflow_Interpreter_Interpret.termToRuntime(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.defaultLocation)(ctx);
                                    return function ($267) {
                                        return $265($266($267));
                                    };
                                })())(getNodeValue(currentFunction)(v.valueMap)(id)(node)));
                                var colorMap = (function () {
                                    if (node instanceof Lunarbox_Data_Editor_Node.InputNode) {
                                        return Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_Node_PinLocation.ordPin)))(Control_Bind.bind(Data_Maybe.bindMaybe)(nodeGroup)(function (group) {
                                            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.AtFunction(currentFunction))(v.typeMap))(function (ty) {
                                                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Functor.map(Data_Map_Internal.functorMap)(Lunarbox_Capability_Editor_Type.typeToColor)(Lunarbox_Capability_Editor_Type.inputNodeType(group)(id)(ty)));
                                            });
                                        }));
                                    };
                                    return Lunarbox_Capability_Editor_Type.generateColorMap(function (pin) {
                                        return Data_Function.flip(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation))(v.typeMap)(Lunarbox_Data_Editor_Location.InsideFunction.create(currentFunction)(new Lunarbox_Data_Editor_Node_PinLocation.PinLocation(id, pin)));
                                    })(node);
                                })();
                                return Effect_Class.liftEffect(dictMonadEffect)(Lunarbox_Foreign_Render.refreshInputArcs(cache)(id)({
                                    inputs: Data_Functor.map(Data_Functor.functorArray)(Data_Nullable.toNullable)(inputs),
                                    value: value,
                                    colorMap: Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Tuple.uncurry(go))({
                                        output: Data_Nullable["null"],
                                        inputs: Data_Unfoldable.replicate(Data_Unfoldable.unfoldableArray)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(inputs))(Data_Nullable["null"])
                                    })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(colorMap))
                                }));
                            });
                        });
                    }));
                });
            }));
        };
    };
};
var createNode = function (dictMonadEffect) {
    return function (dictMonadState) {
        return function (name) {
            var isInput = Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(name)(inputNodeName);
            var create = Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.get(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity)))(function (state) {
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(function (v) {
                    return Data_Semigroup.append(Lunarbox_Data_Editor_Node_NodeId.semigroupNodeId)(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name) + "-")(v);
                })(createId))(function (id) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.gets(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Fold.preview(_atInputCount(name)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(function (desiredInputCount) {
                        var maxInputs = (function () {
                            if (isInput) {
                                return 0;
                            };
                            return getMaxInputs(name)(state);
                        })();
                        var inputCount = Data_Maybe.fromMaybe(maxInputs)(Control_Bind.join(Data_Maybe.bindMaybe)(desiredInputCount));
                        var node = (function () {
                            if (isInput) {
                                return Lunarbox_Data_Editor_Node.InputNode.value;
                            };
                            return new Lunarbox_Data_Editor_Node.ComplexNode({
                                inputs: Data_Unfoldable.replicate(Data_List_Types.unfoldableList)(inputCount)(Data_Maybe.Nothing.value),
                                "function": name
                            });
                        })();
                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(withCurrentFunction_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(function (currentFunction) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over(_nodes(currentFunction)(Data_Lens_Internal_Wander.wanderFunction))(Data_Map_Internal.insert(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(id)(node))))(function () {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(isInput)(Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                                    var $268 = _atFunctionData(currentFunction)(Data_Lens_Internal_Wander.wanderFunction);
                                    var $269 = Data_Lens_Prism_Maybe["_Just"](Data_Profunctor_Choice.choiceFn);
                                    var $270 = Lunarbox_Data_Editor_FunctionData["_FunctionDataInputs"](Data_Profunctor_Strong.strongFn);
                                    return function ($271) {
                                        return $268($269($270($271)));
                                    };
                                })())(function (v) {
                                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ {
                                        name: "input",
                                        description: "The input of a custom function"
                                    } ]);
                                })))(function () {
                                    return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Lens_Setter.over((function () {
                                        var $272 = _currentNodeGroup(Data_Profunctor_Strong.strongFn);
                                        var $273 = Data_Lens_Prism_Maybe["_Just"](Data_Profunctor_Choice.choiceFn);
                                        var $274 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupInputs"](Data_Profunctor_Strong.strongFn);
                                        return function ($275) {
                                            return $272($273($274($275)));
                                        };
                                    })())(function (v) {
                                        return Data_Semigroup.append(Data_List_Types.semigroupList)(v)(Control_Applicative.pure(Data_List_Types.applicativeList)(id));
                                    }));
                                })))(function () {
                                    return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(compile);
                                });
                            });
                        }))(function () {
                            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(new Data_Tuple.Tuple(id, inputCount));
                        });
                    });
                });
            });
            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Control_Monad_State.runState(create)))(function (v) {
                return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Getter.view(_currentGeometryCache(Data_Lens_Internal_Forget.strongForget))))(Data_Foldable.traverse_((dictMonadEffect.Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(function (cache) {
                    var displayName = (function () {
                        if (isInput) {
                            return Data_Nullable["null"];
                        };
                        return Data_Nullable.notNull(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name));
                    })();
                    return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Lunarbox_Foreign_Render.createNode(cache)(v.value0.value0)(v.value0.value1)(true)(displayName)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Data_Functor["void"]((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Control_Monad_State_Class.put(dictMonadState)(v.value1)))(function () {
                            return updateNode(dictMonadState)(dictMonadEffect)(v.value0.value0);
                        });
                    });
                }));
            });
        };
    };
};
var updateAll = function (dictMonadState) {
    return function (dictMonadEffect) {
        return withCurrentFunction(dictMonadState)(function (name) {
            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Getter.view(_atGeometry(name)(Data_Lens_Internal_Forget.strongForget))))(function (cache) {
                return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)))(Data_Map.keys))(Control_Monad_State_Class.gets(dictMonadState)(Data_Lens_Fold.preview(_nodes(name)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst))))))(Data_Foldable.traverse_((dictMonadEffect.Monad0()).Applicative0())(Data_Set.foldableSet)(updateNode(dictMonadState)(dictMonadEffect))))(function () {
                    return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(cache);
                });
            });
        });
    };
};
module.exports = {
    emptyState: emptyState,
    createId: createId,
    inputNodeName: inputNodeName,
    updateNode: updateNode,
    createNode: createNode,
    getOutputType: getOutputType,
    generateUnconnectableInputs: generateUnconnectableInputs,
    generateUnconnectableOutputs: generateUnconnectableOutputs,
    tryCompiling: tryCompiling,
    compile: compile,
    evaluate: evaluate,
    canConnect: canConnect,
    createConnection: createConnection,
    setCurrentFunction: setCurrentFunction,
    initializeFunction: initializeFunction,
    removeConnection: removeConnection,
    deleteNode: deleteNode,
    deleteFunctionReferences: deleteFunctionReferences,
    deleteFunction: deleteFunction,
    visualFunctionCount: visualFunctionCount,
    nodeCount: nodeCount,
    searchNode: searchNode,
    functionExists: functionExists,
    preventDefaults: preventDefaults,
    withCurrentFunction: withCurrentFunction,
    withCurrentFunction_: withCurrentFunction_,
    withCurrentGeometries: withCurrentGeometries,
    withCurrentNode_: withCurrentNode_,
    getMaxInputs: getMaxInputs,
    getNodeValue: getNodeValue,
    updateAll: updateAll,
    getFunctionColorMap: getFunctionColorMap,
    MoveToFunction: MoveToFunction,
    CenterNode: CenterNode,
    CenterOutput: CenterOutput,
    moveTo: moveTo,
    getNodeType: getNodeType,
    "_inputCountMap": _inputCountMap,
    "_atInputCount": _atInputCount,
    "_valueMap": _valueMap,
    "_runtimeOverwrites": _runtimeOverwrites,
    "_geometries": _geometries,
    "_atGeometry": _atGeometry,
    "_functionData": _functionData,
    "_atFunctionData": _atFunctionData,
    "_project": _project,
    "_expression": _expression,
    "_typeMap": _typeMap,
    "_nextId": _nextId,
    "_functions": _functions,
    "_nodeGroup": _nodeGroup,
    "_nodes": _nodes,
    "_atNode": _atNode,
    "_function": _function,
    "_currentFunction": _currentFunction,
    "_panelIsOpen": _panelIsOpen,
    "_currentTab": _currentTab,
    "_currentNodeGroup": _currentNodeGroup,
    "_currentGeometryCache": _currentGeometryCache,
    "_currentNodes": _currentNodes,
    "_atCurrentNode": _atCurrentNode,
    "_name": _name,
    "_isExample": _isExample,
    "_isAdmin": _isAdmin,
    "_isVisible": _isVisible,
    "_nodeSearchTerm": _nodeSearchTerm
};
